exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-input[data-v-2ee36ece]{direction:ltr}.direction-label[data-v-2ee36ece]{text-align:left}", ""]);

// exports
